<template>
	<permits-item v-if="show" :color="'#FF5722'">
		<div class="c1">
			<div class="icon"></div>
			<div>
				<h1>{{ $t('Smart Notifications') }}</h1>
				<p>{{ $t('Enable notifications so you don\'t miss alerts from your patients.') }}</p>
			</div>
		</div>
		<template v-slot:footer>
			<action-button v-if="notifications.prompt" :color="'rgba(0,0,0,0.5)'" :title="$t('Enabled smart notifications')" @click="requestPermission"/>
			<action-button v-if="notifications.denied" :color="'rgba(0,0,0,0.5)'" :title="$t('Blocked. How to unlock?')" @click="howToUnlock"/>
			<action-button v-if="notifications.granted" :color="'rgba(0,0,0,0.5)'" :title="$t('Active smart notifications')"/>
		</template>
	</permits-item>
</template>

<script>
import { mapGetters } from 'vuex'
import PermitsItem from '@/modules/permits/PermitsItem'
import ActionButton from '@/modules/ui/ActionButton'
export default {
	name: 'permits-item-notification',
	components: {
		PermitsItem,
		ActionButton
	},
	methods: {
		async checksPermission() {
			const query = await navigator.permissions.query({name:'notifications'})

			if (query.state === 'prompt')
			{
				this.$store.dispatch('PUT_STATE_NOTIFICATIONS', { granted: false, denied: false, prompt: true })
			}
			else if (query.state === 'denied')
			{
				this.$store.dispatch('PUT_STATE_NOTIFICATIONS', { granted: false, denied: true, prompt: false })
			}
			else if (query.state === 'granted')
			{
				this.$store.dispatch('PUT_STATE_NOTIFICATIONS', { granted: true, denied: false, prompt: false })
			}
		},
		requestPermission() {
			if (this.notifications.prompt) {
				this.$root.$emit('notification-request', {})
			}
		},
		howToUnlock() {
			this.$appModal.show({
				title: this.$t('How to Unlock'),
				message: this.$t('To unlock you must go browser settings to our app and change the notification permission to "Ask" again.')
			})
		}
	},
	computed: {
		show() {
			return this.notifications.prompt || this.notifications.denied
		},
		...mapGetters({
			notifications: 'GET_NOTIFICATIONS'
		})
	},
	created() {
		this.checksPermission()
		this.$root.$on('notification-update-status', () => this.checksPermission())
	}
}
</script>

<style scoped>
.c1 {
	display: flex;
}
.icon {
	margin: 15px 0 0 10px;
	display: block;
	width: 50px;
	height: 50px;
	flex: 0 0 50px;
	background-image: url(/static/svg/buttons/notification.svg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/modules/permits/PermitsItemNotification.vue